import api from "../services/index";

const addTenantApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTenantUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/tenant/create`,
        method: "POST",
        body: payload,
      }),
    }),
    getAllTenants: builder.query({
      query: () => "api/tenant/getAllTenants",
    }),
    getTenantDetails: builder.query({
      query: (payload) => ({
        url: `api/tenant/fetchtenant?tenantMongoId=${payload}`,
        method: "GET",
      }),
    }),
    getUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/tenant/updatetenant?tenantMongoId=${id}`,
        method: "PUT",
        body: payload,
      }),
    }),
    getAnnouncement: builder.query({
      query: () => ({
        url: `/api/announcement/getAll`,
        method: "GET",
      }),
    }),
    createProxyAdmin: builder.mutation({
      query: ({ payload }) => ({
        url: `/api/tenant/createproxyadmin`,
        method: "POST",
        body: payload,
      }),
    }),
    getProxyAdminsDrilldown: builder.query({
      query: ({ tenantId, employeeId }) =>
        `/api/tenant/proxyadmin/drilldown?tenantId=${tenantId}&employeeId=${employeeId}`,
    }),
    revokeProxyAdmin: builder.mutation({
      query: ({ tenantId, employeeId }) => ({
        url: `/api/tenant/revokeproxyadmin?tenantId=${tenantId}&employeeId=${encodeURIComponent(employeeId)}`,
        method: "DELETE",
      }),
    }),
    grantProxyAdmin: builder.mutation({
      query: ({ tenantId, employeeId }) => ({
        url: `/api/tenant/grantproxyadmin?tenantId=${tenantId}&employeeId=${employeeId}`,
        method: "PUT",
      }),
    }),
  }),
});

export default addTenantApi;
export const {
  useCreateTenantUpdateMutation,
  useGetAllTenantsQuery,
  useLazyGetTenantDetailsQuery,
  useGetUpdateMutation,
  useGetAnnouncementQuery,
  useCreateProxyAdminMutation,
  useLazyGetProxyAdminsDrilldownQuery,
  useRevokeProxyAdminMutation,
  useGrantProxyAdminMutation,
} = addTenantApi;
